// Module
var code = "<template>\n  <div class=\"error form-element--has-error\">\n    <span style=\"display: block\" class=\"help-block\" repeat.for=\"error of displayErrors\"> ${error.message} </span>\n  </div>\n</template>\n";
// Exports
export default code;